import React, { useEffect, useRef, useState } from "react"
import { gsap } from "gsap"
import Confetti from "react-confetti"
import { Redirect } from "react-router-dom"

import EventLogo from "../images/serviceAwards.svg"
import { years } from "../services/timelineService"
import { PropTypes } from "prop-types"
const sampleData = require("../fixtures/content.json")
function Splash(props) {
  const showInstruction = useRef(false)
  const [shouldRedirectTl, setShouldRedirectTl] = useState(false)
  const [shouldRedirectFind, setShouldRedirectFind] = useState(false)
  const confettiRef = useRef(null)

  const horizontal = [
    0.25 * window.innerWidth,
    -0.25 * window.innerWidth,
    0.5 * window.innerWidth,
    -0.5 * window.innerWidth,
    0.75 * window.innerWidth,
    -0.75 * window.innerWidth,
    1 * window.innerWidth,
    1 * window.innerWidth,
    1.25 * window.innerWidth,
    -1.25 * window.innerWidth,
    1.5 * window.innerWidth,
    -1.5 * window.innerWidth,
    1.75 * window.innerWidth,
    -1.75 * window.innerWidth,
    2 * window.innerWidth,
    2 * window.innerWidth,
  ]
  const vertical = [
    1.25 * window.innerHeight,
    -1.25 * window.innerHeight,
    1.5 * window.innerHeight,
    -1.5 * window.innerHeight,
    1.75 * window.innerHeight,
    -1.75 * window.innerHeight,
  ]
  const yearTl = gsap.timeline({
    repeat: -1,
  })
  useEffect(() => {
    ;[
      ...document.getElementsByClassName("splash-container__years__year"),
    ].forEach((ea) => {
      gsap.set(ea, { opacity: 0, scale: 1 })
      yearTl
        .to(
          ea,
          {
            scale: 8,
            x: horizontal[Math.floor(Math.random() * horizontal.length)],
            y: vertical[Math.floor(Math.random() * vertical.length)],
            duration: 20,
            ease: "power1.in",
          },
          "-=17"
        )
        .to(
          ea,
          {
            opacity: 0.5,
            delay: 3,
            duration: 17,
          },
          "<"
        )
    })

    gsap.set(".splash-container__welcome", {
      opacity: 0,
    })

    if (props.location.state) {
      handleSplashOld()
    } else {
      setTimeout(() => {
        if (!showInstruction.current) {
          handleSplashClick()
        }
      }, 2500)
    }
    // handleSplashOld()
  })

  let fadedYears = years
    .filter((ea) => !isNaN(parseInt(ea)))
    .map((ea) => {
      return (
        <div className='splash-container__years__year'>
          <h1>{ea}</h1>
        </div>
      )
    })

  const handleSplashOld = () => {
    gsap.set(".splash-container__logo__wrapper", {
      y: "-35%",
      scale: 0.5,
    })
    gsap.set(confettiRef.current, {
      opacity: 0,
      display: "none",
    })
    gsap.set(
      [".splash-container__welcome", ".splash-container__welcome__child"],
      { opacity: 1 }
    )
    showInstruction.current = true
  }

  const handleSplashClick = () => {
    gsap.to(".splash-container__logo__wrapper", {
      y: "-35%",
      scale: 0.5,
      ease: "power3.inOut",
      duration: 2,
    })
    gsap.to(confettiRef.current, {
      opacity: 0,
      duration: 2,
      onComplete: () => {
        gsap.set(confettiRef.current, {
          display: "none",
        })
      },
    })
    gsap.set(".splash-container__welcome", { opacity: 1 })
    gsap.fromTo(
      ".splash-container__welcome__child",
      { opacity: 0 },
      {
        opacity: 1,
        stagger: 0.3,
        duration: 1,
        delay: 1,
      }
    )

    showInstruction.current = true
  }

  const clickLink = (location) => {
    gsap.to(
      [
        ".splash-container__logo__wrapper",
        ".splash-container__welcome",
        ".splash-container__years",
      ],
      {
        opacity: 0,
        duration: 0.5,
        onComplete: () => {
          if (location === "/timeline") {
            setShouldRedirectTl(true)
          } else if (location === "/search") {
            setShouldRedirectFind(true)
          }
        },
      }
    )
  }

  if (shouldRedirectTl) {
    return <Redirect to='/timeline' />
  }

  if (shouldRedirectFind) {
    return <Redirect to='/search' />
  }

  return (
    <>
      <Confetti
        width={window.innerWidth}
        height={window.innerHeight}
        colors={["#FFEF64"]}
        ref={confettiRef}
      />
      <div
        className='splash-container'
        onClick={() => {
          if (props.location.state || showInstruction.current) {
            handleSplashOld()
          } else {
            handleSplashClick()
          }
        }}
      >
        <div className='splash-container__logo__wrapper'>
          <img src={EventLogo} className='splash-container__logo' alt='event logo' />
        </div>
        <div className='splash-container__welcome'>
          <h1 className='splash-container__welcome__child splash-container__welcome__head'>
            {sampleData.welcome.title}
          </h1>
          <p className='splash-container__welcome__child splash-container__welcome__copy'>
            {sampleData.welcome.copy}
          </p>
          <p className='splash-container__welcome__child splash-container__welcome__copy splash-container__welcome__cta'>
            {sampleData.welcome.cta}
          </p>
          <button
            onClick={(e) => {
              e.preventDefault()
              clickLink("/timeline")
            }}
            className='splash-container__welcome__child splash-container__welcome__tl-button splash-container__welcome__link-button'
          >
            Explore the timeline
          </button>
          <button
            onClick={(e) => {
              e.preventDefault()
              clickLink("/search")
            }}
            className='splash-container__welcome__child splash-container__welcome__list-button splash-container__welcome__link-button'
          >
            Find Someone
          </button>
        </div>
        <div className='splash-container__years'>{fadedYears}</div>
      </div>
    </>
  )
}

Splash.propTypes = {
  location: PropTypes.object.isRequired
}

export default Splash
